module.exports = __webpack_public_path__ + "62614c0d03f694975809bd526281e1d9.png";